import { useAppStateSelector, useSelectedFiltersCount, useSort, pick } from "@nosto/preact"
import { sortOptions } from "../config"
import Select from "./elements/Select"
import { toggleButtonId } from "./Sidebar"

function ToggleMobileSidebarButton({ selectedFiltersCount }) {
    return (
        <label
            for={toggleButtonId}
            className="ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ns-align-items-center"
        >
            <span>Filters</span>
        </label>
    )
}

export default function Toolbar() {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )

    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.getAttribute("sort-value"))
    }

    const docCount = response.products?.total ?? 0
    const totalSummary = pageType === "category" ? `${response?.products?.categoryPath}` : `'${query.query}' - ${docCount} results`
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))
    const activeString = sortOptions.filter(opt => opt.id == activeSort)[0].value.name;

    return (
        <div
            class="ns-header-controls ns-d-flex ns-flex-column ns-flex-md-row ns-d-none ns-d-md-flex  ns-flex-wrap align-center ns-justify-content-between ns-pt-o ns-pr-2 ns-pb-1 ns-pl-2"
            style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            {!loading && (
                <span
                    class="ns-d-none ns-text-align-center ns-d-md-block ns-order-md-first ns-align-self-md-center ns-header-info"
                    data-nosto-element="totalResults"
                >
                    {totalSummary}
                </span>
            )}
            <div class="ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block">
                <ToggleMobileSidebarButton
                    selectedFiltersCount={selectedFiltersCount}
                />
                <Select
                    value={activeSort}
                    activeString={activeString}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu"
                    options={options}
                    label={"Sort by"}
                />
            </div>
        </div>
    )
}
